// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"8516d45c","660":"918eab09","774":"3e58188c","854":"2486c058","883":"25e96339"}[chunkId] + ".chunk.js";
};